import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import React from 'react';

// Admin-only page. No NavItemBlueprint on purpose: the custom AppShell renders
// the sidebar itself and shows the "Access" entry only to portal admins.
const accessRouteRef = createRouteRef();

const accessPage = PageBlueprint.make({
  name: 'access',
  params: {
    path: '/access',
    routeRef: accessRouteRef,
    loader: () =>
      import('./AccessPage').then(m => React.createElement(m.AccessPage)),
  },
});

export const accessModule = createFrontendModule({
  pluginId: 'app',
  extensions: [accessPage],
});
